<template>
  <div class="rank-box">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>全国学科评估</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="zy-school">
      <div class="rank-infor">
        <h3>全国学科评估</h3>
        <p>按学科对全国大学进行评估，直观的评分可以让学生在选择院校时按照自己的意向学科进行筛选。</p>
      </div>
      <div class="rank-content">
        <el-row class="collapse-box">
            <el-col :span="8" style="background: #f7f9fc;border: 1px solid #f0f2f5;margin-top: 20px;padding: 0 24px;border-radius: 8px;">
              <el-collapse v-model="activeNames" class="rank-content-collapse">
                 <el-collapse-item v-for="(item, index) in cateList" :key="index" :title="item.parent_name" :name="index">
                   <div v-for="(item1, index1) in item.children" :key="index1" class="rank-type-item" :class="activeTypeIndex === index + '-' + index1 ? 'rank-type-item-active':''" @click="changeCateTypeHandler(index, index1, item1)">{{ item1.special_name}}</div>
                  </el-collapse-item>
              </el-collapse>
            </el-col>
            <el-col :span="16" style="padding-left: 32px;">
              <div class="select-type-name">{{ selectCateObj.special_name ? selectCateObj.special_name + '评估': '' }}</div>
              <div v-if="schoolList.length == 0">
                <ContentLoader  v-for="item in 12"  :key="item" primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="73" width="450" viewBox="0 0 450 73">
                  <rect x="55" y="18" width="117" height="13" />
                  <rect x="55" y="40" width="250" height="14" />
                  <rect x="0" y="68" width="655" height="1" />
                  <circle cx="20" cy="35" r="20" />
                </ContentLoader>
              </div>
              <div class="collapse-list" v-else v-for="(item,index) in schoolList" :key="index" @click="schoolDetailHandler(item.scl_id)">
                  <el-col :span="3" style="width:13%">
                    <el-image :src="'https://gaokao.zmpajx.com/pic/' + item.scl_id + '.jpg'" alt="大学logo">
                        <div slot="error" class="image-slot">
                            <img src="../../assets/images/scl_default.png" alt="大学logo">
                        </div>
                    </el-image>
                  </el-col>
                  <el-col :span="19">
                  <div class="zytb-school-name">
                      {{item.scl_name}}<img src="../../assets/images/wz.png" alt="位置" v-if="item.scl_location">
                      <span v-if="item.scl_location">{{item.scl_location}}</span>
                  </div>
                  <div class="zytb-school-tag">
                    <!-- <template v-if="item.scl_nature_type == '6000'">
                      <span v-if="item.f211 == '1' || item.f985 == '1' || item.is_provincial == '1' || (item.dual_class != '38003' && item.dual_class)">
                        本科
                      </span>
                      <span v-else>
                        普通本科
                      </span>
                    </template>
                    <template v-if="item.scl_nature_type == '6001'">
                        <span v-if="item.is_doublehigh == '77'">
                          专科
                        </span>
                        <span v-else>
                          普通专科
                        </span>
                      </template> -->
                       <span>{{type_edu[item.scl_nature_type]}}</span>
                        <span v-if="item.scl_type == '5000'">综合</span>
                        <span v-if="item.scl_type == '5001'">理工</span>
                        <span v-if="item.scl_type == '5002'">农林</span>
                        <span v-if="item.scl_type == '5003'">医药</span>
                        <span v-if="item.scl_type == '5004'">师范</span>
                        <span v-if="item.scl_type == '5005'">语言</span>
                        <span v-if="item.scl_type == '5006'">财经</span>
                        <span v-if="item.scl_type == '5007'">政法</span>
                        <span v-if="item.scl_type == '5008'">体育</span>
                        <span v-if="item.scl_type == '5009'">艺术</span>
                        <span v-if="item.scl_type == '5010'">民族</span>
                        <span v-if="item.scl_type == '5011'">军事</span>
                        <span v-if="item.scl_type == '5012'">其他</span>
                        <span v-if="item.scl_nature == '36000'">公办</span>
                        <span v-if="item.scl_nature == '36001'">民办</span>
                        <span v-if="item.scl_nature == '36002'">中外合作办学</span>
                      <span v-if="item.f211 == '1'" style="background:#fff4e3;color:#fe9f0a;">211</span>
                      <span v-if="item.f985 == '1'" style="background:#fff0e9;color:$common-color;">985</span>
                      <span v-if="item.dual_class != '38003' && item.dual_class" style="background:#e4f4e9;color:#01c13b;">双一流</span>
                      <span v-if="item.is_provincial == '1'" style="background: #FDEFFF;color: #D250E0">省重点</span>
                      <span v-if="item.is_doublehigh == '77'" style="background: #ECEDFF;color: #5964FF">双高计划</span>
                  </div>
                  </el-col>
                  <el-col :span="4">
                    评级：<span>{{item.rank}}</span>
                  </el-col>
                  <div class="con-clear"></div>
                  <el-row class="con-line" style="width: 100%"></el-row>
              </div>
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :total="totalData" :page-size="12" @current-change="changePageData" :current-page.sync="currentPage" v-if="totalData > 0 && schoolList.length > 0">
              </el-pagination>
            </el-col>
        </el-row>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getCategoryList, getEvaluationList } from '@/api/rank'
import { getSearchDic } from "@/api/zhiyuan"
import { ContentLoader } from 'vue-content-loader'
export default {
    components: {
        ContentLoader
    },
  data() {
    return {
      schoolList: [],
      totalData: 0,
      currentPage: 1,
      cateList: [],
      selectCateObj: {},
      activeTypeIndex:'0-0',
      activeNames: [0],
      allSchoolList: [],
      type_edu: {}
    }
  },
  created() {
    this.$store.commit('user/ADDCOUNT', 0);
    this.getSearchDicHandler();
    setTimeout(()=>{
      this.getCategoryHandler('1');
    }, 200)
  },
  methods: {
    getSearchDicHandler() {
      try {
        getSearchDic().then(res => {
          if (res.status != 200 || !res) {
            return
          }
          res.data.edu_type.map( item => {
            this.type_edu[item.dic_code] = item.dic_value
          })
        }).catch(error => {
          console.log(error);
        })
      } catch (error) { console.log(error) }
    },
    changePageData(page) {
      this.schoolList = [];
      this.schoolList = this.allSchoolList.slice((page - 1) * 12,page * 12)
    },
    schoolDetailHandler(scl_id) {
      this.$router.push({
        path:'/schoolDetail',
        query: {
            scl_id: scl_id
        }
      })
    },
    getCategoryHandler() {
      getCategoryList().then(res => {
        if(res.data.length === 0) {
          return
        }
        this.cateList = res.data
        this.selectCateObj = res.data[0].children[0]
        this.getEvaluationHandler()
      })
    },
    getEvaluationHandler() {
      getEvaluationList(this.selectCateObj.id).then(res => {
        this.allSchoolList = res.data.evaluation_list
        this.schoolList = res.data.evaluation_list.slice((this.currentPage - 1) * 12,(this.currentPage) * 12)
        this.totalData = res.data.evaluation_list.length
      })
    },
    changeCateTypeHandler(index, index1, data) {
      this.activeTypeIndex = index + '-' + index1
      this.selectCateObj = data
      this.schoolList = []
      this.allSchoolList = []
      this.currentPage = 1
      this.getEvaluationHandler()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/css/variables.scss";
  @font-face {
    font-family: 'DINCond-Black';
    src: url('../../assets/fonts/DINCond-Black.otf');
  }
  .zy-school {
    @include gwidth;
    margin-top: 24px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10); 
    padding: 16px 24px;
    .el-col-16 {
      position: relative;
      padding-left: 16px;
      text-align: center;
      .rank-content {
        h4 {
          font-size: 20px;
          font-weight: 600;
          color: #2c2e33;
          text-align: left;
          margin: 0;
          padding-bottom: 13px;
          border-bottom: 1px solid #f0f2f5;
        }
      }
    }
  }
  .collapse-box {
		width: 100%;
    min-height: 330px;
		font-size: 0;
		img, .el-image {
			width: 64px;
			height: 64px;
		}
		.el-col-3 {
			width: 11%;
		}
      .el-col-4 {
          float: right;
      }
      .zytb-school-name {
          font-size: 18px;
          font-weight: 600;
          color: #2c2e33;
          margin-bottom: 5px;
      }
      .zytb-school-tag span {
          display: inline-block;
          padding: 3px 8px;
          font-size: 12px;
          color: #909399;
          height: 22px;
          background: #f0f2f5;
          border-radius: 4px;
          line-height: 22px;
          margin-right: 4px;
      }
      .zytb-school-major {
          color: #3272ff;
          font-size: 14px;
          margin-top: 20px;
          position: relative;
          right: -6px;
      }
      .zytb-school-name img {
          width: 16px;
          height: 16px;
          position: relative;
          top: 2px;
          left: 5px;
          margin-left: 5px;
      }
      .zytb-school-name span {
          color: #909399;
          font-size: 12px;
          font-weight: 400;
          position: relative;
          top: -2px;
          left: 5px;
      }
      .zytb-school-tag {
          margin-top: 10px;
      }
      button {
          width: 100px;
          height: 30px;
          border: 1px solid #3272ff;
          border-radius: 5px;
          color: #3272ff;
          font-size: 14px;
          text-align: center;
          line-height: 30px;
          padding: 0;
          margin-top: 15px;
          background-color: #fff;
      }
      .el-col-4 {
          text-align: right;
      }
      button:hover {
          background-color: #fff;
      }
      .con-line {
          width: calc(100% - 45px);
          height: 1px;
          background: #f0f2f5;
          position: absolute;
          right: 0;
          bottom: 0;
      }
      .rank-number {
        width: 28px;
        height: 28px;
        font-size: 20px;
        font-family: 'DINCond-Black';
        text-align: center;
        color: #5e6166;
      }
      .el-col-2 {
        width: 5.5%;
      }
      .rank-top {
        width: 28px;
        height: 28px;
      }
      .el-col-4 {
        font-size: 14px;
        color: #5e6166;
        text-align: right;
        width: 20.5%;
        span {
          font-size: 14px;
          color: #fe9f0a;
          font-weight: 600;
        }
      }
    }
    .select-type-name {
      width: 100%;
      font-size: 18px;
      font-weight: 600;
      color: #2c2e33;
      text-align: left;
      margin-top: 20px;
    }
    .collapse-list {
      padding: 20px 0;
      position: relative;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      text-align: left;
      cursor: pointer;
    }
    .rank-infor {
      width: 100%;
      height: 176px;
      background: url('../../assets/images/rank.jpg') no-repeat;
      background-size: 100% 100%;
      padding: 32px;
      box-sizing: border-box;
      h3 {
        color: #ffffff;
        font-weight: 600;
        font-size: 22px;
        margin: 0 auto;
      }
      p {
        width: 70%;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255,255,255,0.70);
        line-height: 24px;
      }
    }
</style>